<template>
  <div>
    <div class="header-wrapper">
      <div class="header-title">
        ONBOARDING PROCCESS
      </div>
    </div>
    <div
      class="row"
    >
      <div class="col-12 d-flex justify-content-center">
        <!-- STEP 1 -->
        <z-card
          v-if="step == 1"
          class="onboarding-card"
        >
          <loading
            :show="loading.init"
            :text="''"
          />
          <div class="row">
            <div class="col-12">
              <h2>
                STEP 1
              </h2>
              <div class="sub-title">
                CONTACT INFORMATION
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <z-input-text
                v-model="email"
                label="Email"
                disabled
              />
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-4">
              <div class="input-text-wrapper">
                <label>CONTACT ME VIA</label>
                <el-select
                  v-model="form.messenger_id"
                  placeholder="Select"
                >
                  <el-option
                    v-for="item in selects.messenger"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </div>
            </div>
            <div class="col-12 col-md-8">
              <z-input-text
                v-model="form.messenger"
                label="Messenger ID"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="input-text-wrapper">
                <label>COUNTRY</label>
                <el-select
                  v-model="form.country_id"
                  placeholder="Select"
                  filterable
                >
                  <el-option
                    v-for="item in selects.countries"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </div>
            </div>
            <div class="col-12">
              <div class="input-text-wrapper">
                <label>LANGUAGES</label>
                <el-select
                  v-model="form.lang_ids"
                  placeholder="Select"
                  filterable
                  multiple
                >
                  <el-option
                    v-for="item in selects.languages"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <z-button
                style="margin: 0 auto;"
                class="pt-6 mb-4"
                :loading="loading.submit"
                @click="submitStep1"
              >
                Next step
              </z-button>
            </div>
          </div>
        </z-card>

        <!-- STEP 2 -->
        <z-card
          v-if="step == 2"
          class="onboarding-card"
        >
          <loading
            :show="loading.init"
            :text="''"
          />
          <div class="row">
            <div class="col-12">
              <h2>
                STEP 2
              </h2>
              <div class="sub-title">
                CHOOSE GAMES
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <z-radio-slider
                v-model="form.game_id"
                :items="selects.games"
              />
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-12">
              <div class="sub-title">
                PLATFORM YOU PLAY ON
              </div>
            </div>
            <div class="col-12">
              <div class="checkbox-custom-group">
                <div
                  v-for="item in selects.platforms"
                  :key="item.id"
                  class="radio-item"
                >
                  <label>
                    <input
                      v-model="item.selected"
                      type="checkbox"
                      @change="form[item.field_name] = ''"
                    >
                    <span class="checkbox-custom-wrap">
                      <i :class="`icon ${item.icon}`" />
                      <span class="checkbox-custom-name">
                        {{ item.name }}
                      </span>
                      <span class="check-icon">
                        <i class="icon icon-check-2" />
                      </span>
                    </span>
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div
              v-for="(field, index) in account_fields_list"
              :key="index"
              class="col-12"
            >
              <z-input-text
                v-model="form[field.field_name]"
                :label="field.label"
              />
            </div>
          </div>

          <div class="row mt-4">
            <div class="col-12">
              <div class="d-flex justify-content-center">
                <z-button
                  class="pt-6 mb-4 mr-2"
                  btn-class="btn-link"
                  @click="backToStep(1)"
                >
                  Back
                </z-button>
                <z-button
                  class="pt-6 mb-4 ml-2"
                  :loading="loading.submit"
                  :disabled="!account_fields_list.length"
                  @click="submitStep2"
                >
                  Next step
                </z-button>
              </div>
            </div>
          </div>
        </z-card>

        <z-card
          v-if="step == 3"
          class="onboarding-card"
        >
          <loading :show="loading.init" />
          <div class="row">
            <div class="col-12">
              <h2>
                STEP 3
              </h2>
              <div class="sub-title">
                RESULTS
              </div>
            </div>
          </div>

          <div
            v-if="!loading.init"
            class="row mb-3"
          >
            <div class="col-12">
              <table class="result-table">
                <thead>
                  <tr>
                    <th />
                    <th style="width: 100px;">
                      KD
                    </th>
                    <th style="width: 100px;">
                      KILLS
                    </th>
                    <th style="width: 100px;">
                      WINS
                    </th>
                    <th style="width: 180px;" />
                  </tr>
                </thead>
                <tbody>
                  <tr class="min-row">
                    <td align="left">
                      MIN
                    </td>
                    <td>{{ stats.min.kd_ratio }}</td>
                    <td>{{ stats.min.kills }}</td>
                    <td>{{ stats.min.wins }}</td>
                    <td />
                  </tr>
                  <tr
                    v-for="(row, index) in stats.data"
                    :key="index"
                    :class="{allow: row.success}"
                  >
                    <td>
                      <div class="username">
                        <i :class="['icon platform-icon', row.icon]" />
                        <span>{{ row.login }}</span>
                      </div>
                    </td>
                    <template v-if="!row.error">
                      <td class="value">
                        {{ row.kd_ratio }}
                      </td>
                      <td class="value">
                        {{ row.kills }}
                      </td>
                      <td class="value">
                        {{ row.wins }}
                      </td>
                    </template>
                    <template v-else>
                      <td
                        class="value"
                        colspan="3"
                      >
                        {{ row.error }}
                      </td>
                    </template>
                    <td>
                      <i :class="['icon', row.success ? 'icon-check': 'icon-close' ]" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col-12 d-flex justify-content-center">
              <z-button
                class="pt-6 mb-4 mr-2"
                btn-class="btn-link"
                @click="backToStep(2)"
              >
                Back
              </z-button>
              <z-button
                btn-class="btn-success"
                :disabled="!stats.allowApply"
                @click="request"
              >
                APPLY
              </z-button>
            </div>
          </div>
        </z-card>
      </div>
    </div>
  </div>
</template>

<script>
import ZCard from '@/components/shared/ZCard.vue';
import ZInputText from '@/components/shared/input/ZInputText.vue';
import ZButton from '@/components/shared/buttons/ZButton.vue';
import onboardingAPI from '@/api/onboarding';
import ZRadioSlider from '../components/shared/input/ZRadioSlider/ZRadioSlider.vue';
import Loading from '../components/shared/Loading.vue';

export default {
  components: {
    ZCard,
    ZInputText,
    ZButton,
    ZRadioSlider,
    Loading,
  },

  data: () => ({
    loading: {
      init: false,
      submit: false,
      getStats: false,
    },
    email: '',
    step: null,
    fetchStatsInterval: null,
    timerGetStats: 0,
    form: {
      email: '',
      country_id: '',
      messenger: '',
      messenger_id: '',
      lang_ids: [],
      game_id: 2,
      pc_id: null,
      xbox_id: null,
      psn_id: null,
    },
    account_fields: [
      { platform_id: 1, label: 'BATTLE.NET', field_name: 'pc_id' },
      { platform_id: 2, label: 'XBOX LIVE', field_name: 'xbox_id' },
      { platform_id: 3, label: 'PSN', field_name: 'psn_id' },
      { platform_id: 4, label: 'ACTIVISION ID', field_name: 'acti_id' },
    ],
    stats: {
      min: {
        kills: null,
        wins: null,
        kd_ratio: null,
      },
      data: [],
      allowApply: false,
    },
    selects: {
      messenger: [],
      countries: [],
      games: [],
      languages: [],
      platforms: [
        {
          id: 1, name: 'PC', icon: 'icon icon-pc', field_name: 'pc_id', selected: false,
        },
        {
          id: 2, name: 'XBOX', icon: 'icon icon-xbox', field_name: 'xbox_id', selected: false,
        },
        {
          id: 3, name: 'PLAYSTATION', icon: 'icon icon-playstation', field_name: 'psn_id', selected: false,
        },
        {
          id: 4, name: 'ACTIVISION', icon: 'icon icon-acti', field_name: 'acti_id', selected: false,
        },
      ],
    },
  }),

  computed: {
    account_fields_list() {
      const selectedPlatform = this.selects.platforms.map((i) => {
        if (i.selected) {
          return i.id;
        }
        return undefined;
      }).filter((i) => i !== undefined);

      return this.account_fields.filter((i) => selectedPlatform.includes(i.platform_id));
    },
  },

  created() {
    this.init();

    if (this.$store.getters.isApproved) {
      this.$router.push('/');
    }

    this.email = this.$store.getters.user.email;
  },

  methods: {

    init() {
      this.loading.init = true;
      onboardingAPI.init()
        .then((response) => {
          if (response.data.success) {
            this.selects.countries = response.data.data.countries;
            this.selects.games = response.data.data.games.map((i) => {
              i.icon = `/img/games/logos/${i.image}`;
              return i;
            });
            this.selects.messenger = response.data.data.messenger;
            this.selects.languages = response.data.data.languages;
            this.step = response.data.data.step;
            this.form = response.data.data.form;

            if (this.step === '3') {
              this.startFetchStats();
            }
          }
        })
        .finally(() => {
          this.loading.init = false;
        });
    },

    submitStep1() {
      this.loading.init = true;
      onboardingAPI.savestep1(this.form)
        .then((response) => {
          if (response.data.success) {
            this.step = 2;
          } else {
            this.$toast.error(response.data.messages.join('<br>'));
          }
        })
        .catch((err) => {
          throw new Error(err);
        })
        .finally(() => {
          this.loading.init = false;
        });
    },

    submitStep2() {
      this.loading.init = true;
      this.timerGetStats = 0;
      this.stats.data = [];
      onboardingAPI.savestep2(this.form)
        .then((response) => {
          if (response.data.success) {
            this.step = 3;
            this.startFetchStats();
          } else {
            this.loading.init = false;
            this.$toast.error(response.data.messages.join('<br>'));
          }
        })
        .catch((err) => {
          throw new Error(err);
        });
    },

    startFetchStats() {
      this.loading.init = true;
      this.fetchStatsInterval = setInterval(() => this.getWarzoneStats(), 5000);
      this.getWarzoneStats();
    },

    backToStep(step) {
      this.loading.init = true;
      onboardingAPI.backToStep(step)
        .then((response) => {
          if (response.data.success) {
            this.step = step;
            this.timerGetStats = 0;
          }
        }).catch((err) => {
          throw new Error(err);
        })
        .finally(() => {
          this.loading.init = false;
        });
    },

    getWarzoneStats() {
      this.timerGetStats += 1;
      onboardingAPI.warzoneStats()
        .then((response) => {
          if (!response.data.success) {
            this.$toast.error('Sorry, something went wrong, contact technical support...');
            clearInterval(this.fetchStatsInterval);
            this.backToStep(2);
            return;
          }

          if (!response.data.data.wait || this.timerGetStats > 12) {
            clearInterval(this.fetchStatsInterval);

            this.stats.data = response.data.data.data;
            this.stats.min = response.data.data.min_warzone_stat;
            this.stats.allowApply = response.data.data.success;
            this.loading.init = false;
          }
        });
    },

    request() {
      this.loading.init = true;
      onboardingAPI.request()
        .then((response) => {
          if (!response.data.success) {
            this.$toast.error('Sorry, something went wrong, contact technical support...');
          } else {
            this.$router.push('/onboarding/pending');
          }
        })
        .catch((err) => {
          throw new Error(err);
        })
        .finally(() => {
          this.loading.init = false;
        });
    },

  },
};
</script>

<style lang="scss" scoped>
.header-wrapper {
  position: relative;
  height: 180px;
  background-image: url('/img/header-bg.jpg');
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  display: flex;
  justify-content: center;
  align-items: center;

  .header-title {
    text-align: center;
    z-index: 2;
    font-family: var(--font-bold);
    font-size: 34px;
    text-transform: uppercase;
    color: #fff;
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
    background: linear-gradient(271.62deg, rgba(225, 81, 0, 0.8) 0.84%, rgba(255, 135, 0, 0.8) 99.32%);
  }
}

.onboarding-card {
  position: relative;
  overflow: hidden;
  min-height: 350px;
  margin-top: 30px;
  max-width: 750px;
  padding: 30px;
  padding-bottom: 0;
  width: 100%;

  h2 {
    width: 100%;
    text-align: center;
    color: var(--color-secondary);
    font-family: var(--font-bold);
    font-size: 24px;
    padding: 0;
    margin: 0;
  }

  .sub-title {
    margin-top: 3px;
    text-align: center;
    font-size: 16px;
    color: #fff;
    font-family: var(--font-bold);
  }
}

.checkbox-custom-group {
  background: var(--color-blue-400);
  padding: 10px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 10px;
  border-radius: 10px;

  .radio-item {
    position: relative;
    display: flex;
    align-items: center;
    height: 80px;
    font-size: 24px;

    .checkbox-custom-wrap {
      border-radius: 10px;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .checkbox-custom-name {
      font-size: 14px;
      font-family: var(--font-bold);
      margin-left: 10px;
    }

    label {
      line-height: 1;

      &:hover {
        cursor: pointer;

        input:checked ~ .checkbox-custom-wrap {
          background: var(--color-secondary);
        }

        input ~ .checkbox-custom-wrap {
          background: var(--color-blue-100);
        }
      }
    }

    .check-icon {
      display: none;
    }

    input {
      position: absolute;
      opacity: 0;
      width: 0;
      height: 0;
      cursor: pointer;

      &:checked ~ .checkbox-custom-wrap {
        background: var(--color-secondary);

        .check-icon {
          display: block;
          position: absolute;
          top: 8px;
          right: 8px;
          font-size: 18px;
        }
      }
    }
  }
}

.result-table {
  width: 100%;
  font-weight: 600;

  th {
    font-size: 18px;
    text-align: center;
    padding: 10px;
  }

  td {
    color: var(--color-white);
    text-align: center;
    padding: 10px;
    border-top: 1px var(--color-blue-200) solid;

    &:first-of-type {
      text-align: left;
    }
  }

  .platform-icon {
    font-size: 38px;
  }

  .username {
    max-width: 50px;
    min-width: 130px;
    display: flex;
    align-items: center;

    span {
      margin-left: 10px;
      text-transform: uppercase;
    }
  }

  .icon-check {
    color: var(--color-success-100);
  }

  .icon-close {
    color: var(--color-danger-100);
  }

  tbody {
    .min-row {
      td {
        color: var(--color-secondary);
        font-size: 18px;
        border-top: none;
        padding-top: 0;
      }
    }

    tr {
      .value {
        color: var(--color-danger-100);
      }

      &.allow {
        .value {
          color: var(--color-success-100);
        }
      }
    }
  }
}

@media screen and (max-width: 767px) {
  .header-wrapper {
    height: 80px;

    .header-title {
      font-family: var(--font-bold);
      font-size: 20px;
    }

    img {
      height: 60px;
    }
  }

  .checkbox-custom-group {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media screen and (max-width: 480px) {
  .checkbox-custom-group {
    grid-template-columns: repeat(1, 1fr);
  }
}
</style>
